import { Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { ELEMENT_COLOR, ELEMENT_COLOR_VALUE } from "@/constants";

const useStyles = makeStyles({
  container: {
    display: "flex",
    gap: 32,
  },
  fieldContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 16,
  },
  fieldContent: {
    display: "flex",
    gap: "16px",
  },
  colorButtonContainer: {
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid #757575",
    cursor: "pointer",
  },
  colorButton: {
    width: "24px",
    minWidth: "24px",
    height: "24px",
    borderRadius: "50%",
    padding: 0,
  },
  activeColor: {
    border: "2px solid #F50561",
  },
});

const fields = [
  {
    id: 1,
    type: "color",
    title: "Background Color",
    values: [ELEMENT_COLOR.DARK, ELEMENT_COLOR.LIGHT, ELEMENT_COLOR.DEFAULT],
  },
  {
    id: 2,
    type: "textColor",
    title: "Text Color",
    values: [ELEMENT_COLOR.DARK, ELEMENT_COLOR.LIGHT, ELEMENT_COLOR.DEFAULT],
  },
];

export default function ElementColorField(props) {
  const { formValues, setValue } = props;

  const classes = useStyles();

  return (
    <div className={classes.container} data-testid="color-field-container">
      {fields.map((field) => (
        <Box key={field.type} className={classes.fieldContainer}>
          <span>{field.title}</span>
          <Box className={classes.fieldContent}>
            {field.values.map((value) => {
              const checked = value === (field.type === "color" ? formValues.color : formValues.textColor);

              return (
                <div
                  key={`${field.type}-${value}`}
                  className={`${classes.colorButtonContainer} ${checked ? classes.activeColor : ""}`}
                  onClick={() => setValue(field.type, value, { shouldDirty: true })}
                >
                  <Button
                    className={classes.colorButton}
                    style={{ background: ELEMENT_COLOR_VALUE[value] }}
                    data-testid={`${field.type}-${value.toLowerCase()}`}
                  />
                </div>
              );
            })}
          </Box>
        </Box>
      ))}
    </div>
  );
}
